import { createFileRoute } from '@tanstack/react-router'

// Param-only route: the UI lives in the parent `/agents/$agentId/chat` route (MastraChat),
// which reads `agentId` and `uuid` from the URL to load the matching thread.
export const Route = createFileRoute('/_app/agents/$agentId/chat/$uuid')({
  component: () => null,
})

export const AgentsChatThreadRoute = Route
